import { Component, EventEmitter, Input, Output , OnInit, ViewChild, OnChanges } from '@angular/core';

import { IdiomaCalendario } from '../../../domain/IdiomaCalendatio';
import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'app-range-filter',
    templateUrl: './rangeFilter.component.html',
    styleUrls: ['./rangeFilter.component.scss'],
    providers: []
  })


  export class RangefilterComponent implements OnInit{

    @Input() uiClass = 'ui-g-3';
    @Input() uiClassDate = 'ui-g-3';
    @Input() uiClassSep = 'ui-g-1';
    @Output() onChangeRange: EventEmitter <any> = new EventEmitter();

    idiomaCalendario: IdiomaCalendario;

    muestraFechasRango = false;
    FechaInicioRango = new Date();
    FechaFinRango = new Date();
    tiposRango = [
      {label: this.translate.instant('Dashboard.mesactual'), value: 'mes_actual'},
      {label: this.translate.instant('Dashboard.mesanterior'), value: 'mes_anterior'},
      {label: this.translate.instant('Dashboard.ultimos30dias'), value: 'ultimos_30_dias'},
      {label: this.translate.instant('Dashboard.hoy'), value: 'hoy'},
      {label: this.translate.instant('Dashboard.ultimos5minutos'), value: 'ultimos_5_min'},
      {label: this.translate.instant('Dashboard.personalizar'), value: 'otros'}
    ];


    ngOnInit(): void {
      console.log('Componente RangefilterComponent CARGADO');
    }

    constructor(
        private translate: TranslateService
    ){

      this.idiomaCalendario = new IdiomaCalendario();
      this.idiomaCalendario.firstDayOfWeek = 1;
      this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
      this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
      this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
      this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
      this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
      this.idiomaCalendario.today = this.translate.instant('Calendario.today');
      this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

    }


    cambiarTipoRango(change){
        console.log(change.value);
        const hoy = new Date();
        let inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1, hoy.getHours(), hoy.getMinutes());
        let fin = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0, hoy.getHours(), hoy.getMinutes());
        let lastMinutes = null;
        let numTipo = 0;

        this.muestraFechasRango = false;

        let isEmited = true;

        switch (change.value){
          case 'mes_actual':
            break;
          case 'mes_anterior':
            inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
            fin = new Date(hoy.getFullYear(), hoy.getMonth() , 0);
            numTipo = 1;
            break;
          case 'ultimos_30_dias':
            inicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 30);
            fin = hoy;
            numTipo = 2;
            break;
          case 'hoy':
            inicio = hoy;
            fin = hoy;
            numTipo = 3;
            break;
          case 'ultimos_5_min':
            inicio = hoy;
            fin = hoy;
            lastMinutes = 5;
            numTipo = 4;
            break;
          case 'otros':
            inicio = hoy;
            fin = hoy;
            this.muestraFechasRango = true;
            isEmited = false;
            numTipo = 5;
            break;
        }

        const dev = {
          inicio: inicio,
          fin: fin,
          lastMinutes: lastMinutes,
          numTipo: numTipo
        };

        if (isEmited) {
          this.onChangeRange.emit(dev);
        }

      }

      cambiarFechaRango(fecha){

        if (this.FechaInicioRango > this.FechaFinRango){
          this.FechaInicioRango = this.FechaFinRango;
          this.FechaFinRango = this.FechaInicioRango;
        }

        const dev = {
          inicio: this.FechaInicioRango,
          fin: this.FechaFinRango
        };

        this.onChangeRange.emit(dev);
      }

	  onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaInicioRango') {
			this.FechaInicioRango = fecha;
		}
		if (tipo === 'FechaFinRango') {
			this.FechaFinRango = fecha;
		}
		this.cambiarFechaRango(fecha);
		calendar.overlayVisible=false;

	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/rangeFilter/rangeFilter.component.ts